<template>
  <div class="card dashboard-card">
    <div class="card-body">
      <div class="row align-items-center">
        <div class="col">
          <h5
            class="card-title mb-2"
            v-html="title"
          />
          <span class="h2 mb-0">
            {{ count }}
          </span>
        </div>
        <div class="col-auto">
          <span class="h2 fe fe-dollar-sign text-muted mb-0">
            <slot />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: [
    'title', 'count',
  ],
};
</script>

<style lang="scss">
.dashboard-card {
	.card-body {
		padding: 15px 20px 20px;

		.card-title {
			height: 18px;
			line-height: 18px;
			font-size: 12px;
			font-weight: normal;
			letter-spacing: -0.5px;
			color: #9b9b9b;
			margin-bottom: 2px;
		}

		.h2 {
			display: block;
			font-size: 20px;
			font-weight: normal;
			letter-spacing: -0.8px;
			color: #4a4a4a;
			line-height: 29px;
			height: 29px;
		}
	}

  .el-loading-mask {
    border-radius: 5px;
  }
}
</style>
